import cx from "classnames";
import { type ReactNode } from "react";

import "./CollapsingCardMenu.css";

type CollapsingCardMenuDirection = "up" | "down" | "left" | "right";

export type CollapsingCardMenuProps = {
  children: ReactNode;
  // up is default
  direction?: CollapsingCardMenuDirection;
};

export function CollapsingCardMenu(props: CollapsingCardMenuProps) {
  const { children, direction = "up" } = props;
  return (
    <div className={cx("collapsing-card-menu-list", direction)}>{children}</div>
  );
}
